class DetailsModal extends HTMLElement {
	constructor() {
		super();
		this.header = document.querySelector(".header-wrapper");
		// The password page modal (PasswordModal) is still <details>/<summary>
		this.detailsContainer =
			this.querySelector(".header__region-container") ||
			this.querySelector("details");
		this.summaryToggle =
			this.querySelector(".header__region-summary") ||
			this.querySelector("summary");
		this.isDetails = this.detailsContainer.matches("details");
		this.header.preventHide = false;

		this.detailsContainer.addEventListener("keyup", (event) => {
			if (event.code !== "Escape" || !this.isOpen()) return;
			// Consumed here: an enclosing menu drawer must not close on the same keypress
			event.stopPropagation();
			this.close();
		});
		this.summaryToggle.addEventListener(
			"click",
			this.onSummaryClick.bind(this)
		);
		this.querySelector(".region-modal__close, .modal__close-button").addEventListener(
			"click",
			this.close.bind(this)
		);

		if (this.summaryToggle.matches("summary"))
			this.summaryToggle.setAttribute("role", "button");
	}

	isOpen() {
		return this.isDetails
			? this.detailsContainer.hasAttribute("open")
			: this.detailsContainer.classList.contains("is-open");
	}

	setOpen(open) {
		if (this.isDetails) {
			this.detailsContainer.toggleAttribute("open", open);
		} else {
			this.detailsContainer.classList.toggle("is-open", open);
		}
	}

	onSummaryClick(event) {
		event.preventDefault();
		if (this.isOpen()) {
			this.close();
			this.header.preventHide = false;
		} else {
			this.open(event);
			if (!this.header) return;
			this.header.preventHide = this.isOpen();
		}
	}

	onBodyClick(event) {
		if (
			!this.contains(event.target) ||
			event.target.classList.contains("modal-overlay")
		)
			this.close(false);
	}

	open(event) {
		this.closeBurgerMenu();
		// Before trapping: a sibling closing on this same click would drop the new trap
		document.querySelectorAll("details-modal").forEach((modal) => {
			if (modal !== this && modal.isOpen()) modal.close(false);
		});

		this.onBodyClickEvent =
			this.onBodyClickEvent || this.onBodyClick.bind(this);
		this.setOpen(true);
		document.body.addEventListener("click", this.onBodyClickEvent);
		document.body.classList.add("overflow-hidden");
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);

		trapFocus(
			this.detailsContainer.querySelector('[tabindex="-1"]'),
			this.detailsContainer.querySelector(".region-modal__close") ||
				this.detailsContainer.querySelector('input:not([type="hidden"])')
		);
	}

	close(focusToggle = true) {
		const toggleToFocus = focusToggle ? this.summaryToggle : null;
		this.setOpen(false);
		// Inside the mobile menu drawer: hand the focus trap back to the drawer dialog. menu-opening,
		// not is-open: is-open lingers through the 400ms close animation.
		const drawer = this.closest(".menu-drawer-container.menu-opening")?.closest("menu-drawer, header-drawer");
		if (drawer) trapFocus(drawer.trapContainer, toggleToFocus);
		else removeTrapFocus(toggleToFocus);
		document.body.removeEventListener("click", this.onBodyClickEvent);
		document.body.classList.remove("overflow-hidden");
		document.body.classList.remove(
			`overflow-hidden-${this.dataset.breakpoint}`
		);
		this.header.preventHide = false;
	}

	closeBurgerMenu () {
		// Via <burger-menu>: it owns aria-expanded, the panel's inert attribute and the
		// open-mode flag, which a bare class removal leaves stale.
		const burgerMenu = document.querySelector(".burger-menu--open");
		if (burgerMenu) {
			const burgerMenuHost = burgerMenu.closest("burger-menu");
			if (burgerMenuHost?.collapse) {
				burgerMenuHost.collapse();
			} else {
				burgerMenu.classList.remove("burger-menu--open");
				burgerMenu.querySelector(".burger-menu__overlay")?.classList?.remove("burger-menu__overlay--active");
			}
			document.body.classList.remove("overflow-hidden-drawer");
		}
	}
}

customElements.define("details-modal", DetailsModal);
